import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6" }
const _hoisted_2 = { class: "2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4" }
const _hoisted_3 = { class: "w-full flex flex-col justify-content-center items-center" }
const _hoisted_4 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_5 = { class: "lg:text-lg text-lg text-justify lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-medium lowercase first-letter:capitalize text-2xl text-center lg:leading-9 md:leading-7 leading-9 text-curaduria" }, " DOCUMENTACIÓN GENERAL PARA LICENCIAS"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-justify lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }, [
    /*#__PURE__*/_createElementVNode("ul", {
      role: "list",
      class: "list-disc text-sm px-2"
    }, [
      /*#__PURE__*/_createElementVNode("li", null, " Copia del certificado de libertad y tradición del inmueble o inmuebles objeto de la solicitud, cuya fecha de expedición no sea superior a un mes antes de la fecha de la solicitud. Cuando el predio no se haya desenglobado se podrá aportar el certificado del predio de mayor extensión. "),
      /*#__PURE__*/_createElementVNode("li", null, " El formulario único nacional para la solicitud de licencias debidamente diligenciado por el solicitante. "),
      /*#__PURE__*/_createElementVNode("li", null, " Copia del documento de identidad del solicitante cuando se trate de personas naturales o certificado de existencia y representación legal, cuya fecha de expedición no sea superior a un mes, cuando se trate de personas jurídicas. "),
      /*#__PURE__*/_createElementVNode("li", null, " Poder especial debidamente otorgado, ante notario o juez de la república, cuando se actúe mediante apoderado o mandatario, con la correspondiente presentación personal. "),
      /*#__PURE__*/_createElementVNode("li", null, " Copia del documento o declaración privada del impuesto predial del último año en relación con el inmueble o inmuebles objeto de la solicitud, donde figure la nomenclatura alfanumérica o identificación del predio. Este requisito no se exigirá cuando exista otro documento oficial con base en el cual se pueda establecer la dirección del predio objeto de solicitud. "),
      /*#__PURE__*/_createElementVNode("li", null, " La relación de la dirección de los predios colindantes al proyecto objeto de la solicitud. Se entiende por predios colindantes aquellos que tienen un lindero en común con el inmueble o inmuebles objeto de solicitud de licencia. "),
      /*#__PURE__*/_createElementVNode("li", null, " Este requisito no se exigirá cuando se trate de predios rodeados completamente por espacio público o ubicados en zonas rurales no suburbanas. "),
      /*#__PURE__*/_createElementVNode("li", null, " Copia de la matrícula profesional de los profesionales intervinientes en el trámite de licencia urbanística y copia de las certificaciones que acrediten su experiencia, para los trámites que así lo requieran. ")
    ])
  ])
], -1)
const _hoisted_7 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-6"
}
const _hoisted_8 = { class: "w-full flex items-center justify-between p-6 space-x-6" }
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = { class: "flex items-center space-x-3" }
const _hoisted_11 = { class: "text-curaduria text-md font-medium truncate" }
const _hoisted_12 = { class: "mt-1 text-gray-500 text-sm" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm font-semibold mt-1 text-curaduriaDark cursor-pointer"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "-mt-px flex divide-x divide-gray-200" }
const _hoisted_16 = { class: "w-0 flex-1 flex" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "ml-3" }
const _hoisted_19 = { class: "-ml-px w-0 flex-1 flex" }
const _hoisted_20 = ["href", "download"]
const _hoisted_21 = { class: "ml-3 text-curaduria" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_EyeIcon = _resolveComponent("EyeIcon")
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")
  const _component_ModalImage = _resolveComponent("ModalImage")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("documents.title")), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("documents.des")), 1)
        ]),
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
            return (_openBlock(), _createElementBlock("li", {
              key: document.title,
              class: "col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200 flex flex-col justify-between"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h3", _hoisted_11, _toDisplayString(document.title), 1)
                  ]),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(document.description), 1),
                  (document.aditionalDocs)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("a", {
                          target: "_blank",
                          href: document.aditionalDocs
                        }, "Documentos adicionales", 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      onClick: $event => (_ctx.showModal(document.imageUrl)),
                      class: "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                    }, [
                      _createVNode(_component_EyeIcon, {
                        class: "w-5 h-5 text-gray-400",
                        "aria-hidden": "true"
                      }),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("documents.buttonSee")), 1)
                    ], 8, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("a", {
                      href: document.imageUrl,
                      download: document.title,
                      id: "imageForDownload",
                      class: "relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                    }, [
                      _createVNode(_component_DownloadIcon, {
                        class: "w-5 h-5 text-curaduria",
                        "aria-hidden": "true"
                      }),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("documents.buttonDownload")), 1)
                    ], 8, _hoisted_20)
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_ModalImage, {
        "modal-visible": _ctx.showModalImage,
        imageUrl: _ctx.imageOpen,
        onClosed: _cache[0] || (_cache[0] = $event => (_ctx.closeModal())),
        onDownload: _cache[1] || (_cache[1] = $event => (_ctx.downloadItem()))
      }, null, 8, ["modal-visible", "imageUrl"])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}